var map = {
	"./algo.png": 89,
	"./appslogo.jpg": 90,
	"./appslogo.png": 91,
	"./edureka.png": 92,
	"./fpg.png": 93,
	"./freelance.svg": 94,
	"./github_logo.png": 95,
	"./guvi.png": 96,
	"./iitbhu.png": 97,
	"./jsFramework.svg": 98,
	"./navodita.jpeg": 99,
	"./nitjlogo.png": 100,
	"./profile.jpg": 101,
	"./xiaomi.png": 102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24;